import React, { FunctionComponent, useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { ICharts, tableType, tabType } from '../context';
import { article } from '@Api';
import cx from 'classnames';
import styles from './fillTable.module.less';


interface IProps {
  tableType: 'fillTable' | 'fillHeader';
  dataSource: ICharts
}

const { fetchHotsell } = article;
const firstHeaderWidthMap = {
  'fillTable': '14%'
}

const TableTd: FunctionComponent<tableType> = ({ title, image, type }) => {

  if (type === 'wordAndImage') {
    return (
      <td className={cx(styles["table-cell"], styles["table-cell-image"])}>
        <img src={image} alt="" />
        {title ? title : '-'}
      </td>
    )
  }

  if (type === 'image') {
    return (
      <td className={cx(styles["table-cell"], styles["table-cell-image"])}>
        <img src={image} alt="" />
      </td>
    )
  }

  return (
    <td className={styles["table-cell"]}>{title ? title : '-'}</td>
  )
}

const firstHeaderWidth = 158;

const fillTable: FunctionComponent<IProps> = ({ tableType, dataSource }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [isShowPrew, setPrew] = useState<boolean>(false);

  const table = useMemo(() => dataSource.chartData as tabType[][], [dataSource]);
  const thead = useMemo(() => !!table.length ? table[0] : [], [table]);
  const tbody = useMemo(() => !!table.length ? table.slice(1, table.length) : [], [table]);

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
    console.log(scrollLeft + scrollValue);
  }, [])

  const handleScroll = () => {
    setPrew(!!(targetRef.current!.scrollLeft))
  }

  useEffect(() => {
    if (targetRef.current) {
      targetRef.current.addEventListener('scroll', handleScroll);
      () => targetRef.current && targetRef.current.addEventListener('scroll', handleScroll);
    }
  }, [])

  return (
    <div className={cx(styles["fill-table"], {
      [styles["fill-header-table"]]: tableType === 'fillHeader',
      [styles["fill-table-radio"]]: dataSource.chartFooterDescription,
      [styles["fixed"]]: thead.length > 5,
    })}>
      <div className={styles["table-container"]}>
        { thead.length > 5 && isShowPrew && <div className={styles['prev']} onClick={() => scrollTo(-785)}></div>}
        <div className={styles["table-content"]} ref={targetRef}>
          <table style={{ width: thead.length > 5 ? thead.length * firstHeaderWidth : '100%' }}>
            <colgroup>
              {
                thead.map((_, inx) => (
                  !inx ?
                  <col style={{ width: firstHeaderWidth }} key={inx}></col> :
                  <col key={inx} style={{ width: thead.length < 3 ? ((784 - firstHeaderWidth) / (thead.length - 1)) / 784 * 100 + '%' : 'auto' }}></col>
                ))
              }
            </colgroup>
            <thead className={styles["table-thead"]}>
              <tr>
                {
                  thead.map((item, inx) => (
                    <th className={styles["table-header table-cell-fix-left"]} key={inx}>{item.title}</th>
                  ))
                }
              </tr>
            </thead>
            <tbody className={styles["table-tbody"]}>
              {
                tbody.map((item, inx) => (
                  <tr key={inx}>
                    {
                      item.map((i, idx) => (
                        <TableTd title={i.title} type={i.type} image={i.image} key={idx} />
                      ))
                    }
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        { thead.length > 5 && <div className={styles['next']} onClick={() => scrollTo(785)}></div>}
      </div>
      { dataSource.chartFooterDescription && <div className={styles['text-extra']}>{dataSource.chartFooterDescription}</div> }
    </div>
  )
}

export default fillTable;